const compact = new Intl.NumberFormat(undefined, { notation: 'compact' })

export function formatCompactNumber(value: number): string {
  if (!Number.isFinite(value)) return '0'
  return compact.format(value)
}
